module.exports = __webpack_public_path__ + "media/images/pen_mediumvioletred-bc316165.png";